"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _task = require("@/api/task");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserTaskLog',
  data: function data() {
    return {
      loading: false,
      total: 0,
      logList: [],
      queryParams: {
        page: 1,
        limit: 10,
        userId: undefined,
        taskName: undefined
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _task.getUserTaskLogList)(this.queryParams).then(function (res) {
        console.log('API返回数据：', res);
        _this.logList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this.$message.error('获取数据失败');
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams.userId = undefined;
      this.queryParams.taskName = undefined;
      this.handleQuery();
    }
  }
};